module.exports = __webpack_public_path__ + "img/success.216fa7fc.svg";